import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CardValueWithLeftColor from '../../../components/common/CardValueWithLeftColor';

const CardQuantoInvesti = (props) => {
	const {
		lancamentos,
		loading,
		title = 'Quanto Investi'
	} = props;

	const [totalInvestimentos, setTotalInvestimentos] = useState(0);

	useEffect(() => {
		setTotalInvestimentos(
			lancamentos &&
				lancamentos.length > 0
				? lancamentos
						.filter((item) => item.tipoLancamento.value === 'investimento')
						.reduce((sum, record) => sum + record.valor, 0)
				: 0
		);


		// eslint-disable-next-line
	}, [lancamentos]);

	return (
		!loading && (
			<CardValueWithLeftColor
				title={title}
				leftColor='border-left-primary'
				icon='fas fa-hand-holding-usd'
				value={totalInvestimentos}
				countup={false}
			/>
		)
	);
};

CardQuantoInvesti.propTypes = {
	title: PropTypes.string
};

const mapStateToProps = (state) => ({
	lancamentos: state.arrumaCasaStore.lancamentos,
	loading: state.commonStore.loading,
});

export default connect(mapStateToProps)(
	CardQuantoInvesti
);
